import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { useContext } from "react";
import { prefixClassname } from "../styles/index.js";
import IndexListContext from "./index-list.context.js";
export default function IndexListIndex(props) {
    const { index } = props;
    const { activeIndex } = useContext(IndexListContext);
    return (React.createElement(View, { className: classNames(prefixClassname("index-list__index"), {
            [prefixClassname("index-list__index--active")]: activeIndex === index,
        }), children: index }));
}
